import {
  CAMPAIGN_VIEW_REQUEST,
  CAMPAIGN_VIEW_FAIL,
  CAMPAIGN_VIEW_SUCCESS,
  LANG_VIEW_REQUEST,
  LANG_VIEW_FAIL,
  LANG_VIEW_SUCCESS,
  ADMIN_VIEW_REQUEST,
  ADMIN_VIEW_FAIL,
  ADMIN_VIEW_SUCCESS,
  TRANSACTION_VIEW_SUCCESS,
  TRANSACTION_VIEW_FAIL,
  TRANSACTION_VIEW_REQUEST,
} from "../constants/campaignConstants";

export const campaignViewReducer = (state = {}, action) => {
  switch (action.type) {
    case CAMPAIGN_VIEW_REQUEST:
      return { loading: true };
    case CAMPAIGN_VIEW_SUCCESS:
      return { loading: false, campaign: action.payload };
    case CAMPAIGN_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const languageViewReducer = (state = {}, action) => {
  switch (action.type) {
    case LANG_VIEW_REQUEST:
      return { loading: true };
    case LANG_VIEW_SUCCESS:
      return { loading: false, language: action.payload };
    case LANG_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const adminViewReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_VIEW_REQUEST:
      return { loading: true };
    case ADMIN_VIEW_SUCCESS:
      return { loading: false, adminDetails: action.payload };
    case ADMIN_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const transactionViewReducer = (state = {}, action) => {
  switch (action.type) {
    case TRANSACTION_VIEW_REQUEST:
      return { loading: true };
    case TRANSACTION_VIEW_SUCCESS:
      return { loading: false, transactionDetails: action.payload };
    case TRANSACTION_VIEW_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
